import { StyleSheet } from 'aphrodite';
import { hexToRGBA } from '../../../../models/UiUtils';
import { brandPrimary, illusionYellow, titles, white } from '../../../styles/colors';
import { ctaButtonReverseProps } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	button: {
		...ctaButtonReverseProps(white, brandPrimary),
		backgroundColor: white,
		fontSize: 14,
		padding: '4px 14px',
	},
	container: {
		alignItems: 'center',
		backgroundColor: hexToRGBA(illusionYellow, 0.25),
		borderColor: illusionYellow,
		borderRadius: 8,
		borderStyle: 'solid',
		borderWidth: 1,
		display: 'flex',
		marginBottom: 10,
		marginTop: 8,
		height: 50,
		padding: '0 4px 0 12px',
		gap: 12,
	},
	ctaContainer: {
		marginRight: 16,
		marginLeft: 'auto',
	},
	iconContainer: {
		margin: 0,
		display: 'flex',
		alignItems: 'center',
	},
	pendingList: {
		marginLeft: 32,
		fontSize: 14,
		display: 'flex',
		gap: 12,
	},
	pendingListItem: {
		color: titles,
		fontSize: 14,
		display: 'flex',
		gap: 4,
	},
	title: {
		color: titles,
		fontSize: 12,
		display: 'inline-block',
		marginRight: 10,
	},
	titleText: {
		color: titles,
		fontSize: 12,
		marginLeft: 8,
	},
});
